import { useMemo } from 'react'
import useActiveWeb3React from '~/hooks/useActiveWeb3React'
import {
  getBep20Contract,
  getCakeContract,
  getIfoV1Contract,
  getIfoV2Contract,
  getMasterchefContract,
  getErc721Contract,
  getCakeVaultContract,
  // getChainlinkOracleContract,
  getSouschefV2Contract,
  getBoosterContract,
  getZapInContract,
  getIfoContract,
  getIfoLinearContract,
  getFairlaunchContract,
  // getFarmZapContract,
  getSouschefContract,
  getNftMarketContract,
  getFeeManager
} from '~/utils/contractHelpers'
import { getMulticallAddress, } from '~/utils/addressHelpers'

// Imports below migrated from Exchange useContract.ts
import { Contract } from '@ethersproject/contracts'
import { ChainId, WETH } from '@pancakeswap/sdk'
import { activeFairlaunch } from '~/config/constants/fairlaunches'
import { abi as IUniswapV2PairABI } from '@uniswap/v2-core/build/IUniswapV2Pair.json'
import ENS_PUBLIC_RESOLVER_ABI from '../config/abi/ens-public-resolver.json'
import ENS_ABI from '../config/abi/ens-registrar.json'
import ERC20_ABI from '../config/abi/erc20.json'
import WETH_ABI from '../config/abi/weth.json'
import multiCallAbi from '../config/abi/Multicall.json'
import fairlaunchERC20ABI from '../config/abi/fairlaunchERC20.json'
// import { getContract } from '../utils'
import {useWalletClient} from "wagmi";
import {erc20Bytes32ABI} from "~/config/abi/erc20Bytes32";

/**
 * Helper hooks to get specific contracts (by ABI)
 */
// export const useIfoV1Contract = (address: string) => {
//   const { library, chainId } = useActiveWeb3React()
//   return useMemo(() => getIfoV1Contract(chainId, address, library.getSigner()), [address, library, chainId])
// }

// export const useIfoV2Contract = (address: string) => {
//   const { library, chainId } = useActiveWeb3React()
//   return useMemo(() => getIfoV2Contract(chainId, address, library.getSigner()), [address, library, chainId])
// }

export const useERC20 = (address: string) => {
  // const { library, chainId } = useActiveWeb3React()
  // return useMemo(() => getBep20Contract(chainId, address, library.getSigner()), [address, library, chainId])
}

/**
 * @see https://docs.openzeppelin.com/contracts/3.x/api/token/erc721
 */
// export const useERC721 = (address: string) => {
//   const { library, chainId } = useActiveWeb3React()
//   return useMemo(() => getErc721Contract(chainId, address, library.getSigner()), [address, library, chainId])
// }

// export const useCake = () => {
//   const { library, chainId } = useActiveWeb3React()
//   return useMemo(() => getCakeContract(chainId, library.getSigner()), [library, chainId])
// }
export const useFeeManager = () => {
  const { chainId } = useActiveWeb3React()
  const { data: signer } = useWalletClient()
  return useMemo(() => getFeeManager(chainId, signer), [signer, chainId])
}


export const useMasterchef = () => {
  const { chainId } = useActiveWeb3React()
  const { data: signer } = useWalletClient()
  return useMemo(() => getMasterchefContract(chainId, signer), [signer, chainId])
}

export const useSousChef = (id) => {
  // const { library, chainId } = useActiveWeb3React()
  // return useMemo(() => getSouschefContract(chainId, id, library.getSigner()), [id, library, chainId])
}

// export const useBoosterChef = (id) => {
//   const { library, chainId, } = useActiveWeb3React()
//   return useMemo(() => getBoosterContract(chainId, id, library.getSigner()), [id, library, chainId])
// }

// export const useZapInContract = () => {
//   const { library, chainId } = useActiveWeb3React()
//   return useMemo(() => getZapInContract(chainId, library.getSigner()), [library, chainId])
// }

// export const useFarmZap = () => {
//   const { library, chainId } = useActiveWeb3React()
//   return useMemo(() => getFarmZapContract(chainId, library.getSigner()), [library, chainId])
// }

// export const useFarmZapContract = () => {
//   const { library, chainId } = useActiveWeb3React()
//   return useMemo(() => getFarmZapContract(chainId, library.getSigner()), [library, chainId])
// }

// export const useFairlaunchContract = () => {
//   const { library, chainId } = useActiveWeb3React()
//   return useMemo(() => getFairlaunchContract(chainId, library.getSigner()), [library, chainId])
// }

// export const useActiveFairlaunchContract = () => {
//   const { library, chainId, account } = useActiveWeb3React()
//   return useMemo(
//     () => getContract(activeFairlaunch(chainId).contractAddress[chainId], fairlaunchERC20ABI, library, account),
//     [library, chainId, account],
//   )
// }

export const useSafeIfoContract = (address?: string, isLinear?: boolean): Contract | undefined => {
  // const { library, chainId } = useActiveWeb3React()
  // return useMemo(() => isLinear ? getIfoLinearContract(chainId, address, library.getSigner()) :
  //             getIfoContract(chainId, address, library.getSigner()), [isLinear, address, library, chainId])
  return undefined
}

// export const useSousChefV2 = (id) => {
//   const { library, chainId } = useActiveWeb3React()
//   return useMemo(() => getSouschefV2Contract(chainId, id, library.getSigner()), [id, library, chainId])
// }






// export const useCakeVaultContract = () => {
//   const { library, chainId } = useActiveWeb3React()
//   return useMemo(() => getCakeVaultContract(chainId, library.getSigner()), [library, chainId])
// }

// export const useChainlinkOracleContract = () => {
//   const { library, chainId } = useActiveWeb3React()
//   return useMemo(() => getChainlinkOracleContract(chainId, library.getSigner()), [library, chainId])
// }


// Code below migrated from Exchange useContract.ts

// returns null on errors
function useContract(address: string | undefined, ABI: any, withSignerIfPossible = true): Contract | null {
  // const { library, account } = useActiveWeb3React()
  //
  // return useMemo(() => {
  //   if (!address || !ABI || !library) return null
  //   try {
  //     return getContract(address, ABI, library, withSignerIfPossible && account ? account : undefined)
  //   } catch (error) {
  //     console.error('Failed to get contract', error)
  //     return null
  //   }
  // }, [address, ABI, library, withSignerIfPossible, account])
  return null
}

export function useTokenContract(tokenAddress?: string, withSignerIfPossible?: boolean): Contract | null {
  return useContract(tokenAddress, ERC20_ABI, withSignerIfPossible)
}

export function useWETHContract(withSignerIfPossible?: boolean): Contract | null {
  const { chainId } = useActiveWeb3React()
  return useContract(chainId ? WETH[chainId].address : undefined, WETH_ABI, withSignerIfPossible)
}

export function useENSRegistrarContract(withSignerIfPossible?: boolean): Contract | null {
  const { chainId } = useActiveWeb3React()
  let address: string | undefined
  if (chainId) {
    // eslint-disable-next-line default-case
    switch (chainId) {
      case ChainId.BSCMAINNET:
      case ChainId.BSCTESTNET:
        address = '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e'
        break
    }
  }
  return useContract(address, ENS_ABI, withSignerIfPossible)
}

export function useENSResolverContract(address: string | undefined, withSignerIfPossible?: boolean): Contract | null {
  return useContract(address, ENS_PUBLIC_RESOLVER_ABI, withSignerIfPossible)
}

export function useBytes32TokenContract(tokenAddress?: string, withSignerIfPossible?: boolean): Contract | null {
  return useContract(tokenAddress, erc20Bytes32ABI, withSignerIfPossible)
}

export function usePairContract(pairAddress?: string, withSignerIfPossible?: boolean): Contract | null {
  return useContract(pairAddress, IUniswapV2PairABI, withSignerIfPossible)
}

export function useMulticallContract(): Contract | null {
  const { chainId } = useActiveWeb3React()
  return useContract(getMulticallAddress(chainId), multiCallAbi, false)
}

// export function useProfile(): Contract | null {
//   return null
// }

// export const useNftMarketContract = () => {
//   const { library, chainId } = useActiveWeb3React()
//   return useMemo(() => getNftMarketContract(chainId, library.getSigner()), [library, chainId])
// }


// export const useContractForCollection = (collectionAddress: string) => {
//   const { library, chainId } = useActiveWeb3React()
//
//
//   return useMemo(() => {
//     // if (collectionAddress === getPancakeRabbitsAddress(chainId)) {
//     //   return getPancakeRabbitContract(chainId, library.getSigner())
//     // }
//     // if (collectionAddress === getPancakeSquadAddress(chainId)) {
//     //   return getPancakeSquadContract(chainId, library.getSigner())
//     // }
//     return getErc721Contract(chainId, collectionAddress, library.getSigner())
//   }, [chainId, library, collectionAddress])
// }
